type EventLocationState = { id: number; name: string; abbr: string }[];

export const EventLocationState: EventLocationState = [
  { id: 1, name: "ACRE", abbr: "AC" },
  { id: 2, name: "ALAGOAS", abbr: "AL" },
  { id: 3, name: "AMAPA", abbr: "AP" },
  { id: 4, name: "AMAZONAS", abbr: "AM" },
  { id: 5, name: "BAHIA", abbr: "BA" },
  { id: 6, name: "CEARÁ", abbr: "CE" },
  { id: 7, name: "DISTRITO FEDERAL", abbr: "DF" },
  { id: 8, name: "ESPÍRITO SANTO", abbr: "ES" },
  { id: 9, name: "GOIAS", abbr: "GO" },
  { id: 10, name: "MARANHÃO", abbr: "MA" },
  { id: 11, name: "MATO GROSSO", abbr: "MT" },
  { id: 12, name: "MATO GROSSO DO SUL", abbr: "MS" },
  { id: 13, name: "MINAS GERAIS", abbr: "MG" },
  { id: 14, name: "PARA", abbr: "PA" },
  { id: 15, name: "PARAIBA", abbr: "PB" },
  { id: 16, name: "PARANÁ", abbr: "PR" },
  { id: 17, name: "PERNAMBUCO", abbr: "PE" },
  { id: 18, name: "PIAUÍ", abbr: "PI" },
  { id: 19, name: "RIO DE JANEIRO", abbr: "RJ" },
  { id: 20, name: "RIO GRANDE DO NORTE", abbr: "RN" },
  { id: 21, name: "RIO GRANDE DO SUL", abbr: "RS" },
  { id: 22, name: "RONDONIA", abbr: "RO" },
  { id: 23, name: "RORAIMA", abbr: "RR" },
  { id: 24, name: "SANTA CATARINA", abbr: "SC" },
  { id: 25, name: "SÃO PAULO", abbr: "SP" },
  { id: 26, name: "SERGIPE", abbr: "SE" },
  { id: 27, name: "TOCANTINS", abbr: "TO" },
];
